import "select2";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.$element = $(this.element)

    if (this.$element.hasClass("tags-select")) {
      this.#initTagsSelect()
    } else if (this.$element.hasClass("ajax-select")) {
      this.#initAjaxSelect()
    } else {
      this.#initDefaultSelect()
    }
  }

  disconnect() {
    this.$element.select2("destroy")
  }

  #initDefaultSelect() {
    this.$element.select2({
      theme: "bootstrap-5",
      width: "100%"
    })
  }

  #initAjaxSelect() {
    var options = {
      theme: "bootstrap-5",
      ajax: {
        url: this.$element.data("source"),
        dataType: "json",
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
            page: params.page,
            per: 10,
            searching: true
          }
        },
        processResults: function (data, _page) {
          return {
            results: data
          }
        },
      },
    }

    this.$element.select2(options)
  }

  #initTagsSelect() {
    var options = {
      theme: "bootstrap-5",
      tags: true
    }

    this.$element.select2(options)

    if (this.$element.hasClass("auto-submit")) {
      this.$element.on("change", function () {
        var form = this.$element.parents("form").get(0)
        window.Rails.fire(form, "submit")
      })
    }
  }
}
